import {
    PhoneOutlined,
    SearchOutlined,
    UserAddOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUserTeamGetTeamsThunk } from "tm-shared/api";
import { WorkStatus } from "tm-shared/types";

import FlexContainer from "@/components/FlexContainer";
import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";

import { TeamMemberBlock, UserInfoDescriptionLink } from "./Styled";

function Team() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { workStatus } = useAppSelector((state) => state.work);
    const { teams } = useAppSelector((state) => state.hr);
    const { type } = useAppSelector((state) => state.theme);

    useEffect(() => {
        dispatch(getUserTeamGetTeamsThunk());
    }, []);
    return (
        <>
            <Meta title="Profile" />
            <Header
                title={
                    workStatus === WorkStatus.StartWork
                        ? "На роботі"
                        : "Не на роботі"
                }
                rightActions={
                    <Button
                        type="text"
                        icon={<UserAddOutlined />}
                        onClick={() => navigate("/add-user-hr")}
                    />
                }
            />

            <MainContainer>
                {teams &&
                    Object?.values(teams)?.map((team, index) => (
                        <TeamMemberBlock key={index}>
                            <FlexContainer
                                width="60%"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                gap="16px"
                            >
                                <Avatar
                                    style={{ width: "62px", height: "42px" }}
                                    icon={
                                        <UserOutlined
                                            style={{
                                                cursor: "pointer",
                                                color:
                                                    type === "dark"
                                                        ? "#ffffff"
                                                        : "#000000",
                                            }}
                                        />
                                    }
                                />
                                <FlexContainer
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    gap="8px"
                                    width="100%"
                                >
                                    <PrimaryText>{team?.teamName}</PrimaryText>
                                    <SecondaryText>
                                        {team?.manager?.fullName}
                                    </SecondaryText>
                                    <FlexContainer
                                        width="100%"
                                        justifyContent="space-between"
                                    >
                                        <UserInfoDescriptionLink
                                            href={`tel:${team?.manager?.phone}`}
                                        >
                                            {team?.manager?.phone}
                                        </UserInfoDescriptionLink>
                                        <UserInfoDescriptionLink
                                            href={`tel:${team?.manager?.phone}`}
                                        >
                                            <PhoneOutlined />
                                        </UserInfoDescriptionLink>
                                    </FlexContainer>
                                </FlexContainer>
                            </FlexContainer>
                            <Avatar
                                style={{
                                    backgroundColor: "#49AA19",
                                    cursor: "pointer",
                                }}
                                size={40}
                                icon={
                                    <SearchOutlined
                                        style={{
                                            cursor: "pointer",
                                            color:
                                                type === "dark"
                                                    ? "#ffffff"
                                                    : "#000000",
                                        }}
                                    />
                                }
                                onClick={() =>
                                    navigate(
                                        `member-info/${team?.manager.userId}/${team?.manager?.roleSlug}`,
                                    )
                                }
                            />
                        </TeamMemberBlock>
                    ))}
            </MainContainer>
        </>
    );
}

export default Team;
